__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-audiences/v5_0_10/";